const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const verified=r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED';

export function deriveEcosystemStrength(rows=[]){
  const source=Array.isArray(rows)?rows:[];
  const ranked=source.filter(r=>verified(r)&&N(r?.importance)!=null);
  const values=[...new Set(ranked.map(r=>N(r.importance)))].sort((a,b)=>a-b);
  const min=values[0]??null,max=values.at(-1)??null,rankable=values.length>=2&&max>min;

  return source.map(row=>{
    const importance=N(row?.importance),share=N(row?.share_estimate_pct);
    if(!verified(row))return{...row,relative_strength_state:'REVIEW',relative_strength_pct:null,strength_basis:'UNVERIFIED_RELATIONSHIP'};
    if(importance==null)return{...row,relative_strength_state:'UNKNOWN',relative_strength_pct:null,strength_basis:'IMPORTANCE_MISSING'};
    if(!rankable)return{...row,relative_strength_state:'UNRANKED',relative_strength_pct:null,strength_basis:'SINGLE_IMPORTANCE_LEVEL'};
    const pct=(importance-min)/(max-min)*100;
    const state=pct>=66.666?'HIGH_RELATIVE':pct>=33.333?'MID_RELATIVE':'LOW_RELATIVE';
    return{...row,share_estimate_pct:share,relative_strength_state:state,relative_strength_pct:pct,strength_basis:'RELATIVE_IMPORTANCE'};
  });
}

export function ecosystemStrengthHealth(rows=[]){
  const derived=deriveEcosystemStrength(rows);
  const verifiedRows=derived.filter(r=>verified(r)).length;
  const rankedRows=derived.filter(r=>['HIGH_RELATIVE','MID_RELATIVE','LOW_RELATIVE'].includes(r.relative_strength_state)).length;
  const unknownRows=derived.filter(r=>['UNKNOWN','UNRANKED','REVIEW'].includes(r.relative_strength_state)).length;
  return{
    status:!derived.length?'MISSING':rankedRows?'LIVE':verifiedRows?'PARTIAL':'REVIEW',
    rows:derived.length,
    verifiedRows,
    rankedRows,
    unknownRows,
    note:'Strength is relative within the selected company ecosystem and uses only the ordering of verified importance values. Confidence and share estimates remain separate evidence.'
  };
}
